import React, { Component } from 'react';
import TagsInput from 'react-tagsinput';
import Form from 'react-jsonschema-form';
import { safeDeepGetWithType } from 'iotera-base/json';
// If using WebPack and style-loader.

function CustomValidate(formData, errors) {

  let pass = safeDeepGetWithType(formData, ['pass'], '');
  let passv = safeDeepGetWithType(formData, ['passv'], '');

  if (pass !== passv) {
    errors.passv.addError("Konforimasi password harus sama!");
  }
  return errors;
}

function CustomTransformErrors(errors) {
  return errors.map((error) => {
    let property = safeDeepGetWithType(error, ['property'], '');
    property = property.slice(1)
    if (error.name === "pattern") {
      let pattern = safeDeepGetWithType(error, ['params', 'pattern'], '');
      if (property === 'appDomain') {
        error.message = "Harus diawali huruf kecil, tidak boleh mengandung huruf kapital (max 16 karakter)"
      } else if (pattern === '^[A-Za-z\\d][A-Za-z\\d_]+$') {
        error.message = "Hanya menerima Alphanumeric dan Underscore"
      } else {
        error.message = "Harus sesuai pattern \"" + pattern + "\""
      }
    } else if (error.name === "required") {
      if (property === 'dashboard') {
        error.message = "Tidak boleh kosong dan konfigurasi harus dalam bentuk object yang benar"
      } else if (property === 'sensors') {
        error.message = "Tidak boleh kosong dan konfigurasi harus dalam bentuk array yang benar"
      } else {
        error.message = "Tidak boleh kosong"
      }
    }
    return error;
  });
}

function CustomTemplate(props) {
  const { id, label, required, children, displayLabel, errors } = props;

  if (id === "root") {
    return (
      <div className={id} >
        {children}
        {errors}
      </div>
    )
  } else {
    if (displayLabel === true) {
      return (
        <div className={id} style={{ marginBottom: '10px' }}>
          <label htmlFor={id} style={{ marginBottom: 5 }}><b>{label}{required ? "*" : <span className='text-iotera-optional'>{' (Optional)'}</span>}</b></label>
          {children}
          {errors}
        </div>
      );
    } else {
      return (
        <div className={id} style={{ marginBottom: '10px' }}>
          {children}
          {errors}
        </div>
      );
    }
  }
}

export function CustomTemplateColumn(props) {
  const { id, label, required, children, displayLabel, errors } = props;

  if (id === "root") {
    return (
      <div className='custom-root' >
        {children}
        {errors}
      </div>
    )
  } else {
    if (displayLabel === true) {
      return (
        <div className='myfield' style={{ marginBottom: '10px' }}>
          <label htmlFor={id} style={{ marginBottom: 5 }}><b>{label}{required ? "*" : <span className='text-iotera-optional'>{' (Optional)'}</span>}</b></label>
          {children}
          {errors}
        </div>
      );
    } else {
      return (
        <div className='myfield' style={{ marginBottom: '10px' }}>
          {children}
          {errors}
        </div>
      );
    }
  }
}

export function CustomTemplateNoMargin(props) {
  const { id, label, required, children, displayLabel, errors } = props;
  let className = "";
  if (displayLabel === true) {
    return (
      <div className={className} >
        <label htmlFor={id} style={{ marginBottom: 5 }}><b>{label}{required ? "*" : <span className='text-iotera-optional'>{' (Optional)'}</span>}</b></label>
        {children}
        {errors}
      </div>
    );
  } else {
    return (
      <div className={className} >
        {children}
        {errors}
      </div>
    );
  }
}

let pattern = new RegExp("^[a-zA-Z][A-Za-z0-9_ ]{0,29}$"); // regex min 1 char, first letter not number, max length 30

export class ArrayFieldTemplate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isChange: false,
      value: []
    }
    this.handleChange = this.handleChange.bind(this);
  }

  handleChang(e) {
    this.setState({
      isChange: true,
      value: e
    })
  }

  render() {
    let props = this.props;
    if (this.state.isChange) {
    }
    return (

      <div className={props.className} >
        <div className='row'>

          <TagsInput
            className="input-mask"
            id="locationTag"
            disabled={false}
            value={props.formData}
            onChange={event => this.handleChange(event)}
            onlyUnique={true}
            validationRegex={pattern}
            maxTags={3}
            inputProps={{ placeholder: "Tag location" }}
            style={{ textAlign: 'left', alignItems: 'left' }}
          />
        </div>
      </div>
    );
  }
}

export class IoteraForm extends Component {
  render() {
    return (
      <Form
        FieldTemplate={CustomTemplate}
        validate={CustomValidate}
        transformErrors={CustomTransformErrors}
        showErrorList={false}
        {...this.props}
      />
    )
  }
}
